export const environment = {
  production: true,
  clientId: "d904ee03c25affc267e6647d3c03532e",
  client_secret:"d63ebfe233fc42dbbbca434b81cc824797718d097",
  authority: "https://csi.slb.com/v2",
  redirect_url: "https://origin.dmaas.slb.com/security/sauth/callback",
  browse_data_api_endpoint: "https://origin.dmaas.slb.com/dmaas2",
  project_data_api_endpoint: "https://origin.dmaas.slb.com/dmaas2",
  insight_api_endpoint: "https://origin.dmaas.slb.com/dmaas2",
  company_name: "origin",
  company_profile: "oil_gas",
  auth_required: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
